import { useState } from "react";
import { ReactComponent as MaeCoreLogoBlack } from "../../assets/logos/MaeCoreLogoBlack.svg";
import { useDealershipContext } from "../../contexts/dealershipContext";
import { useDealershipUserContext } from "../../contexts/dealershipUserContext";
import { MONTHLY_BUDGET_VALUES } from "../../data/budgetData";
import { FEATURE_MAPPING } from "../../data/dealershipQuiz/quizFeatureMapping";
import { ButtonWithCopyIcon } from "../ButtonWithCopyIcon/ButtonWithCopyIcon";
import { FooterPopup } from "../FooterPopup/FooterPopup";

export default function UserProfile({ dealershipImgUrl, carMatches }) {
  const { user, quizIndexMapping } = useDealershipUserContext();
  const { dealershipId, dealershipName } = useDealershipContext();

  const [autovanceCopied, setAutovanceCopied] = useState(false);
  const [autovanceCopyError, setAutovanceCopyError] = useState(false);
  const [showAutovanceFooter, setShowAutovanceFooter] = useState(false);

  const { salesPersonId } = user;

  const ikInputValue =
    user.profile.quiz[quizIndexMapping.IKIDK_INDEX].inputValue;

  let budget = [];
  budget = budget =
    user.profile.quiz[quizIndexMapping.MONTHLY_BUDGET_INDEX]?.selectedOptions
      ?.length > 1
      ? user.profile.quiz[quizIndexMapping.MONTHLY_BUDGET_INDEX].selectedOptions
      : user.profile.quiz[quizIndexMapping.BUDGET_INDEX].selectedOptions;
  let budgetType = budget[1]
    ? budget[1] === "known_range"
      ? "Known Car Price"
      : budget[1] === "monthly"
        ? "Monthly"
        : "Customer Selected Range"
    : "";
  let budgetText = false;
  if (budgetType === "Monthly") {
    budgetText = MONTHLY_BUDGET_VALUES.find((item) => item.value === budget[0]);
    budgetText = budgetText.text;
  } else if (budgetType == "Known Car Price") {
    const [firstValue] = budget[0].split(" - ");
    budgetText = `$${parseInt(firstValue.replace(/[^0-9]/g, "")) + 5000}`;
  } else {
    budgetText = budget[0];
  }

  const copyItemsForAutovance = () => {
    const content = [user.firstName, user.lastName, user.email].join("\t");
    navigator.clipboard
      .writeText(content)
      .then(() => {
        setAutovanceCopied(true);
        setAutovanceCopyError(false);
      })
      .catch((err) => {
        setAutovanceCopied(false);
        setAutovanceCopyError(true);
      });
    setShowAutovanceFooter(true);
  };

  const signatureTerms = `*By clicking ‘Submit’ and signing electronically, you consent to the use of your electronic signature as legally binding under applicable electronic signature laws. You also authorize ${dealershipName} to process your information for test drive scheduling and/or pre-approval purposes.`;
  const financePreApprovalDisclaimer = `Portions of the above information will be submitted for the purposes of obtaining credit. The undersigned authorizes any of the Applewood Group Dealerships to make such inquiries as are necessary to obtain credit information and authorize banks, financial institutions, insurers, and credit references to release information regarding their accounts.
                                You acknowledge that, for the initial application, we may obtain two credit bureaus on each Applicant and Co-Applicant.`;
  const testDriveApprovalDisclaimer = `This test drive agreement (the "Agreement”) is made by and between CUSTOMER . (the "Customer”) and ${dealershipName} (the Dealer”) to set forth the terms under which the Customer may evaluate the vehicle with stock and tag identification numbers as listed above (the "Vehicle”). 
                             Customer hereby agrees to the following:
                            1.) Customer shall only drive the Vehicle from the Start Date and Time until the End Date and Time as defined above.
                            2.) Customer shall be responsible for any and all liabilities (civil, criminal or otherwise) incurred while driving the Vehicle.
                            3.) Customer shall not use the Vehicle for any purpose deemed illicit or illegal, or for any purpose which is otherwise in violation of federal, state or local laws.
                            This Agreement shall in no way imply the transfer of ownership of the Vehicle from Dealer to Customer. 
                            Failure to comply with the terms of this Agreement, including failure to return the Vehicle at or before the Test Drive End Time on the Test Drive End Date, may result in criminal and/or civil proceedings being brought against Customer.
                            I accept full responsibility while using this vehicle. | will provide insurance at or above dealer requirements or state statutes covering liability, physical damage, and bodily injury for myself or any passenger (other than the salesperson) that may arise from the use, operation, maintenance or possession of the vehicle.`;

  return (
    <div
      style={{
        maxWidth: "600px",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
      className="printable"
    >
      <img
        src={dealershipImgUrl}
        alt=""
        style={{ width: "180px", marginLeft: "1rem" }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1 style={{ margin: "0.2rem 1rem" }}>
          {" "}
          {user.firstName} {user.lastName}
        </h1>
        <h5 style={{ marginLeft: "1rem" }}>
          {" "}
          <strong>Salesperson: {salesPersonId}</strong>{" "}
        </h5>
      </div>

      <h4 style={{ marginLeft: "1rem" }}>
        {user.phoneNo}, {user.email} (How did you hear about us?:{" "}
        {user.whereDidYouHereAboutUs})
      </h4>

      <div
        style={{
          width: "fit-content",
          marginBlock: "1rem",
          marginInlineStart: "1rem",
        }}
      >
        <ButtonWithCopyIcon
          buttonText="Autovance"
          clickHandler={copyItemsForAutovance}
          copied={autovanceCopied}
          setCopied={setAutovanceCopied}
          error={autovanceCopyError}
          setError={setAutovanceCopyError}
        />
        {showAutovanceFooter ? (
          autovanceCopyError ? (
            <FooterPopup
              text={"Error copying to clipboard!"}
              destroyFooterPopup={setShowAutovanceFooter}
              timer={1000}
            />
          ) : (
            <FooterPopup
              text={"Copied To Clipboard!"}
              destroyFooterPopup={setShowAutovanceFooter}
              timer={2000}
            />
          )
        ) : null}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        <div
          style={{
            flex: 1,
            background: "rgb(255,204,79,0.5)",
            padding: "1rem",
            borderRadius: "10px",
            border: "2px solid rgb(255,204,79,0.5)",
          }}
        >
          <h3>Car Info</h3>
          {ikInputValue ? (
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Came in for:</strong> {ikInputValue}
            </p>
          ) : (
            ""
          )}
          <p style={{ margin: "0.2rem 0rem" }}>
            <strong>Looking for:</strong>{" "}
            {user.profile.quiz[
              quizIndexMapping.NEW_USED_INDEX
            ].selectedOptions.join(" & ")}{" "}
            {user.profile.quiz[
              quizIndexMapping.VEHICLE_TYPE_INDEX
            ].selectedOptions.join(", ")}
          </p>
          <p style={{ margin: "0.2rem 0rem" }}>
            <strong>Power:</strong>{" "}
            {Array.from(
              new Set(
                user.profile.quiz[
                  quizIndexMapping.VEHICLE_ENGINE_INDEX
                ].selectedOptions
              )
            ).join(", ")}
          </p>
          <p style={{ margin: "0.2rem 0rem" }}>
            <strong>Why?</strong>{" "}
            {user.profile.quiz[
              quizIndexMapping.REASON_NEW_VEHICLE_INDEX
            ].selectedOptions.join(", ")}
          </p>
          {user.profile.quiz[quizIndexMapping.REASON_NEW_VEHICLE_INDEX]
            .inputValue ? (
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Other (specify):</strong>{" "}
              {
                user.profile.quiz[quizIndexMapping.REASON_NEW_VEHICLE_INDEX]
                  .inputValue
              }
            </p>
          ) : (
            ""
          )}
          <p style={{ margin: "0.2rem 0rem" }}>
            <strong>Lifestyle:</strong>{" "}
            {user.profile.quiz[
              quizIndexMapping.LIFESTYLE_INDEX
            ].selectedOptions.join(", ")}
          </p>
          <p style={{ margin: "0.2rem 0rem" }}>
            <strong>Features:</strong>{" "}
            {user.userSelectedFeatures
              .map((feature) => FEATURE_MAPPING[feature]?.text || feature)
              .join(", ")}
          </p>
          {user.profile.quiz[quizIndexMapping.FEATURE_SELECT_INDEX]
            .inputValue ? (
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Feature Notes:</strong>{" "}
              {
                user.profile.quiz[quizIndexMapping.FEATURE_SELECT_INDEX]
                  .inputValue
              }
            </p>
          ) : (
            ""
          )}
          {user.profile.quiz[quizIndexMapping.PICK_CARS_INDEX].selectedOptions
            .length > 0 ? (
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Also considering:</strong>{" "}
              {user.profile.quiz[
                quizIndexMapping.PICK_CARS_INDEX
              ].selectedOptions
                .map(({ make, model }) => {
                  return `${make} ${model}`;
                })
                .join(", ")}
            </p>
          ) : (
            ""
          )}
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div
            style={{
              background: "rgb(255,204,79,0.5)",
              padding: "1rem",
              borderRadius: "10px",
              border: "2px solid rgb(255,204,79,0.5)",
            }}
          >
            <h3>Purchase Info</h3>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Trade In?</strong>{" "}
              {
                user.profile.quiz[quizIndexMapping.TRADE_IN_INDEX]
                  ?.selectedOptions
              }
              , {user.profile.quiz[quizIndexMapping.TRADE_IN_INDEX]?.inputValue}
            </p>
            {quizIndexMapping.TRADE_IN_PAY_OFF_INDEX ? (
              <p style={{ margin: "0.2rem 0rem" }}>
                <strong>Paid off?</strong>{" "}
                {
                  user.profile.quiz[quizIndexMapping.TRADE_IN_PAY_OFF_INDEX]
                    ?.selectedOptions
                }
              </p>
            ) : (
              ""
            )}
            {user.profile.quiz[quizIndexMapping.TRADE_IN_PAY_OFF_INDEX]
              ?.inputValue ? (
              <p style={{ margin: "0.2rem 0rem" }}>
                <strong>Trade In Notes:</strong>{" "}
                {
                  user.profile.quiz[quizIndexMapping.TRADE_IN_PAY_OFF_INDEX]
                    ?.inputValue
                }
              </p>
            ) : (
              ""
            )}
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Downpayment:</strong>{" "}
              {
                user.profile.quiz[quizIndexMapping.PAYMENT_MODE_INDEX]
                  ?.inputValue
              }
            </p>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Budget Type:</strong> {budgetType}
            </p>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Budget:</strong> {budgetText}
            </p>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Financing Option:</strong>{" "}
              {user.profile.quiz[
                quizIndexMapping.PAYMENT_MODE_INDEX
              ].selectedOptions.join(", ")}
            </p>
          </div>
        </div>
      </div>

      {/* <div style={{ background: 'rgb(255,204,79,0.5)', padding: '1rem', borderRadius: '10px', border: '2px solid rgb(255,204,79,0.5)' }}>
  <p>Number of Matches: <strong>{carMatches.length}</strong></p>
  
  {
    carMatches.length === 0 ? null : <p>Matched New Vehicles: <strong>
      {carMatches
      .filter((vehicle)=> (vehicle["raw_condition"] === "New"))
      .map((vehicle) => (`${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim} (${vehicle.raw_stockNumber})`))
      .join(", ")}</strong></p>
  }

  <br></br>

  {
    carMatches.length === 0 ? null : <p>Matched Used Vehicles: <strong>
      {carMatches
      .filter((vehicle)=> (vehicle["raw_condition"] === "Used"))
      .map((vehicle) => (`${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim} (${vehicle.raw_stockNumber})`))
      .join(", ")}</strong></p>
  } 
  </div> */}

      <div style={{ pageBreakAfter: "always" }} />
      <div
        style={{
          background: "rgb(255,204,79,0.5)",
          padding: "1rem",
          borderRadius: "10px",
          border: "2px solid rgb(255,204,79,0.5)",
        }}
      >
        <h3>Test Drive and Finance Pre-approval</h3>
        <p style={{ margin: "0.2rem 0rem" }}>
          <strong>
            Test Drive Approval:{" "}
            {user?.testDriveFinancePreApprovalInfo?.testDriveApproval
              ? "✔"
              : ""}
          </strong>{" "}
        </p>
        <p style={{ fontSize: "0.5rem" }}>{testDriveApprovalDisclaimer}</p>
        <p style={{ margin: "0.2rem 0rem" }}>
          <strong>
            Finance Pre-Approval:{" "}
            {user?.testDriveFinancePreApprovalInfo?.financePreApproval
              ? "✔"
              : ""}
          </strong>{" "}
        </p>
        <p style={{ fontSize: "0.5rem" }}>{financePreApprovalDisclaimer}</p>
        {user?.testDriveFinancePreApprovalInfo ? (
          user?.testDriveFinancePreApprovalInfo?.applicantDetails?.length > 0 &&
          user?.testDriveFinancePreApprovalInfo?.applicantDetails.map(
            (applicantDetail, i) => {
              return (
                <>
                  {user?.testDriveFinancePreApprovalInfo?.applicantDetails
                    ?.length > 1 && (
                    <>
                      <p
                        style={{
                          fontStyle: "italic",
                          textDecoration: "underline",
                        }}
                      >
                        <strong>Applicant {i + 1}</strong>
                      </p>
                      {i > 0 && (
                        <p style={{ margin: "0.2rem 0rem" }}>
                          <strong>
                            FistName: {applicantDetail?.firstName}
                          </strong>{" "}
                        </p>
                      )}
                      {i > 0 && (
                        <p style={{ margin: "0.2rem 0rem" }}>
                          <strong>
                            LastName: {applicantDetail?.lastName}
                          </strong>{" "}
                        </p>
                      )}
                    </>
                  )}
                  <p style={{ margin: "0.2rem 0rem" }}>
                    <strong>
                      Birthday: {applicantDetail?.dateOfBirth}
                    </strong>{" "}
                  </p>
                  {/* <p style={{ margin: "0.2rem 0rem" }}>
                    <strong>SIN: {applicantDetail?.sinNumber}</strong>{" "}
                  </p> */}
                  <p style={{ margin: "0.2rem 0rem" }}>
                    <strong>Address: {applicantDetail?.address}</strong>{" "}
                  </p>
                  <p style={{ margin: "0.2rem 0rem" }}>
                    <strong>
                      Employment Status: {applicantDetail?.employmentStatus}
                    </strong>{" "}
                  </p>
                  <p style={{ margin: "0.2rem 0rem" }}>
                    <strong>
                      Experience: {applicantDetail?.experience}
                    </strong>{" "}
                  </p>
                  <img
                    style={{ margin: "0.2rem 0rem" }}
                    src={applicantDetail?.signature}
                    alt="Signature"
                    className="w-auto h-32"
                  />
                  <p style={{ fontSize: "0.5rem" }}>{signatureTerms}</p>
                </>
              );
            }
          )
        ) : (
          <>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Birthday:</strong>{" "}
            </p>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>SIN:</strong>{" "}
            </p>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Employment Status:</strong>{" "}
            </p>
            <p style={{ margin: "0.2rem 0rem" }}>
              <strong>Experience:</strong>{" "}
            </p>
            <div
              style={{
                margin: "0.2rem 0rem",
                backgroundColor: "white",
                width: "275px",
                height: "150px",
              }}
              className="h-32"
            />
            <p style={{ fontSize: "0.5rem" }}>{signatureTerms}</p>
          </>
        )}
        <p style={{ margin: "0.2rem 0rem" }}>
          <strong>
            Additional Notes:{" "}
            {user?.testDriveFinancePreApprovalInfo
              ? user?.testDriveFinancePreApprovalInfo?.additionalNotes
              : ""}
          </strong>{" "}
        </p>
      </div>
    </div>
  );
}
